import createIcon from '../../createIcon';

/**
 * @component @name SdCardAlert
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMkgxMEw0LjAyIDhMNCAyMEM0IDIxLjEgNC45IDIyIDYgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjRDMjAgMi45IDE5LjEgMiAxOCAyWk0xMyAxN0gxMVYxNUgxM1YxN1pNMTMgMTNIMTFWOEgxM1YxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SdCardAlert = createIcon('SdCardAlert', [
  [
    'path',
    {
      d: 'M18 2H10L4.02 8L4 20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM13 17H11V15H13V17ZM13 13H11V8H13V13Z',
      key: 'eaao1y',
    },
  ],
]);

export default SdCardAlert;
